<template>
  <div>
    <TransitionRoot as="template" :show="mobileMenuOpen">
      <Dialog
        as="div"
        class="relative z-40 lg:hidden"
        @close="mobileMenuOpen = false"
      >
        <TransitionChild
          as="template"
          enter="transition-opacity ease-linear duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="hidden sm:fixed sm:inset-0 sm:block sm:bg-gray-600/75" />
        </TransitionChild>

        <div class="fixed inset-0 z-40">
          <TransitionChild
            as="template"
            enter="transition ease-out duration-150 sm:ease-in-out sm:duration-300"
            enter-from="transform opacity-0 scale-110 sm:translate-x-full sm:scale-100 sm:opacity-100"
            enter-to="transform opacity-100 scale-100 sm:translate-x-0 sm:scale-100 sm:opacity-100"
            leave="transition ease-in duration-150 sm:ease-in-out sm:duration-300"
            leave-from="transform opacity-100 scale-100 sm:translate-x-0 sm:scale-100 sm:opacity-100"
            leave-to="transform opacity-0 scale-110 sm:translate-x-full sm:scale-100 sm:opacity-100"
          >
            <DialogPanel
              class="fixed inset-0 z-40 flex size-full flex-col bg-white sm:inset-y-0 sm:left-auto sm:right-0 sm:w-full sm:max-w-sm sm:shadow-lg"
              aria-label="Global"
            >
              <div
                class="flex shrink-0 grow-0 basis-16 items-center justify-between border-b border-b-gray-200 px-4 sm:px-6"
              >
                <nuxt-link to="/home" @click="mobileMenuOpen = false">
                  <img
                    class="block h-8 w-auto dark:hidden"
                    src="~/assets/img/logo.svg"
                    alt="Rollouter Logo"
                  />
                  <img
                    class="hidden h-8 w-auto dark:block"
                    src="~/assets/img/logo-white.svg"
                    alt="Rollouter Logo"
                  />
                </nuxt-link>
                <button
                  type="button"
                  class="-mr-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                  @click="mobileMenuOpen = false"
                >
                  <span class="sr-only">Close main menu</span>
                  <XMarkIcon class="block size-6" aria-hidden="true" />
                </button>
              </div>
              <div class="flex flex-auto flex-col overflow-y-auto px-4 sm:px-6">
                <div class="mt-6 shrink-0">
                  <div class="-mr-2 flex items-center">
                    <nuxt-link
                      to="/account"
                      class="flex min-w-0 flex-1 cursor-pointer items-center"
                      @click="mobileMenuOpen = false"
                    >
                      <div class="shrink-0">
                        <UserAvatar :user="user" />
                      </div>
                      <div class="ml-3 min-w-0">
                        <div
                          class="truncate text-base font-medium text-gray-900"
                        >
                          {{ user.name }}
                        </div>
                        <div class="truncate text-sm font-medium text-gray-500">
                          {{
                            $t(`roles.${getUserRoleByValue(user.role)}.name`)
                          }}
                        </div>
                      </div>
                    </nuxt-link>
                    <!-- TODO RCP-782 -->
                    <!-- <nuxt-link
                      to="/notifications"
                      class="ml-auto shrink-0 bg-white p-2 text-gray-400 hover:text-gray-500"
                      @click="mobileMenuOpen = false"
                    >
                      <span class="sr-only">View notifications</span>
                      <BellIcon class="size-6" aria-hidden="true" />
                    </nuxt-link> -->
                    <span
                      class="ml-auto shrink-0 cursor-pointer bg-white p-2 text-gray-400 hover:text-gray-500"
                      @click="signOut"
                    >
                      <span class="sr-only">Sign out</span>
                      <ArrowLeftOnRectangleIcon
                        class="size-6"
                        aria-hidden="true"
                      />
                    </span>
                  </div>
                </div>
                <LayoutRolloutSelection class="mt-6 shrink-0" />
                <nav class="my-6 flex flex-auto flex-col justify-between">
                  <ul role="list" class="-mx-2 space-y-1">
                    <li v-for="item in items" :key="item.name">
                      <RolloutLink
                        v-if="!item.subNavigation"
                        v-slot="{ isActive }"
                        :navigation-item="item"
                        active-class="bg-indigo-100 text-indigo-900"
                        inactive-class="hover:bg-gray-50"
                        class="group flex rounded-md p-2 text-sm font-semibold leading-6 text-gray-700"
                        @click="mobileMenuOpen = false"
                      >
                        <component
                          :is="iconMapping[item.name]"
                          class="mr-3 size-6 shrink-0"
                          :class="
                            isActive ? 'text-indigo-400' : 'text-gray-400'
                          "
                          aria-hidden="true"
                        />
                        {{ $t('navigation.' + item.name) }}
                      </RolloutLink>
                      <Disclosure
                        v-else
                        v-slot="{ open, close }"
                        as="div"
                        :default-open="hasActiveSubItem(item)"
                      >
                        {{ registerClose(close) }}
                        <DisclosureButton
                          class="flex w-full items-center rounded-md p-2 text-left text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                         
                        >
                          <component
                            :is="iconMapping[item.name]"
                            class="mr-3 size-6 shrink-0 text-gray-400"
                            aria-hidden="true"
                          />
                          {{ $t('navigation.' + item.name) }}
                          <ChevronDownIcon
                            :class="[
                              open
                                ? 'rotate-180 text-gray-500'
                                : 'text-gray-400',
                              'ml-auto size-5 shrink-0',
                            ]"
                            aria-hidden="true"
                          />
                        </DisclosureButton>
                        <DisclosurePanel
                          as="ul"
                          class="mt-1 px-2"
                         
                        >
                          <li
                            v-for="subItem in item.subNavigation.filter(
                              (item) =>
                                isNavItemAccessible(
                                  item,
                                  selectedRollout,
                                  user.role
                                )
                            )"
                            :key="subItem.name"
                          >
                            <!-- 44px -->
                            <DisclosureButton
                              as="template"
                              @click="mobileMenuOpen = false"
                            >
                              <RolloutLink
                                :navigation-item="subItem"
                                :exact="subItem.renderExact"
                                active-class="bg-indigo-100 text-indigo-900"
                                inactive-class="text-gray-700 hover:bg-gray-50"
                                class="block rounded-md py-2 pl-9 pr-2 text-sm leading-6"
                                :data-testid="
                                  'mobileSidebar.link.' + subItem.name
                                "
                              >
                                {{ $t('navigation.' + subItem.name) }}
                              </RolloutLink>
                            </DisclosureButton>
                          </li>
                        </DisclosurePanel>
                      </Disclosure>
                    </li>
                  </ul>
                  <div
                    class="mt-6 flex items-center justify-center space-x-4 text-gray-400"
                  >
                    <!-- Version -->
                    <a
                      href="//changelog.rollouter.com"
                      target="_blank"
                      class="block text-center text-xs hover:underline"
                    >
                      {{ `v${version}` }}
                    </a>
                  </div>
                </nav>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script lang="ts" setup>
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/vue';
import { XMarkIcon, ArrowLeftOnRectangleIcon } from '@heroicons/vue/24/outline';
import {
  CogIcon,
  HomeIcon,
  ArchiveBoxIcon,
  PresentationChartBarIcon,
  InformationCircleIcon,
  CalendarDaysIcon,
  ChevronDownIcon,
} from '@heroicons/vue/20/solid';

import { useUserStore } from '~~/stores/user';
import { getUserRoleByValue } from '~/config/user-roles';
import type { NavigationItem } from '~/composables/routing';
import { isNavItemAccessible } from '@/util/navigation';
import type { Icon } from '@/types';
import { useRuntimeConfig } from '#imports';

const iconMapping: Record<string, Icon> = {
  home: HomeIcon,
  'rollout-project-rolloutIdentifier-rollout': CalendarDaysIcon,
  'rollout-project-rolloutIdentifier-inventory': ArchiveBoxIcon,
  'rollout-project-rolloutIdentifier-reporting': PresentationChartBarIcon,
  'rollout-project-rolloutIdentifier-knowledge-base': InformationCircleIcon,
  settings: CogIcon,
};

const props = defineProps({
  modelValue: Boolean,
});

const emit = defineEmits(['update:modelValue']);

const mobileMenuOpen = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const { visibleItems: items, currentItems } = useRolloutRouting();

const userStore = useUserStore();
const user = userStore.user;

const { selectedRollout } = useRolloutRouting();

const hasActiveSubItem = (item: NavigationItem) => {
  if (currentItems.value.subNavigationItem) {
    return item.subNavigation?.includes(currentItems.value.subNavigationItem);
  }
  return false;
};

const signOut = () => {
  userStore.signOut();
};

// Close all open submenus after the mobile sidebar closes

const closeFns = ref<(() => void)[]>([]);

const registerClose = (closeFn: () => void) => {
  closeFns.value.push(closeFn);
};

watch(mobileMenuOpen, (newValue) => {
  if (!newValue) {
    closeFns.value.forEach((fn) => fn());
    closeFns.value = [];
  }
});

const runtimeConfig = useRuntimeConfig();
const version = ref(runtimeConfig.public.clientVersion);
</script>
